import React from "react";
import { useLocation } from "react-router-dom";
import logo from "../../Assets/Images/logo.png";

import "@ingka/focus/style.scss";
import "@ingka/hyperlink/style.scss";

import Text from "@ingka/text";
import Hyperlink from "@ingka/hyperlink";

export default function Footer() {
  const location = useLocation();
  return (
    <>
      <footer>
        <div className="container col-2-layout">
          <div>
            <img src={logo} alt="IKEA Systems Logo" />
            <Text tagName="p" headingSize="xs">
              © Inter IKEA Systems B.V. 1999 - {new Date().getFullYear()}
            </Text>
          </div>
          <div>
            <Hyperlink
              className="link--subtle .link--grey"
              url="/"
              text="Devices"
              aria-current={location.pathname === "/" ? "page" : undefined}
            />
            {/* <Hyperlink
              className="link--subtle .link--grey"
              url="http://www.ikea.com"
              text="Customer Suport"
            /> */}
            <Hyperlink
              className="link--subtle .link--grey"
              url="/contact"
              text="Contact Us"
              aria-current={
                location.pathname === "/contact" ? "page" : undefined
              }
            />
          </div>
        </div>
      </footer>
    </>
  );
}
